module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.deno/babel-runtime@6.26.0/~/babel-runtime/core-js/array/from.js
// module id = 177
// module chunks = 0